// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file entity/maintenance.proto (package entity, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { MaintenanceType } from "../consts/constant_pb";

/**
 * Maintenance構造体
 *
 * @generated from message entity.Maintenance
 */
export class Maintenance extends Message<Maintenance> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: constant.MaintenanceType maintenance_type = 2 [json_name = "maintenance_type"];
   */
  maintenanceType = MaintenanceType.ALL;

  /**
   * @generated from field: google.protobuf.Timestamp begin_date = 3 [json_name = "begin_date"];
   */
  beginDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 4 [json_name = "end_date"];
   */
  endDate?: Timestamp;

  /**
   * @generated from field: bool is_enabled = 5 [json_name = "is_enabled"];
   */
  isEnabled = false;

  /**
   * @generated from field: bool is_ios = 6 [json_name = "is_ios"];
   */
  isIos = false;

  /**
   * @generated from field: bool is_android = 7 [json_name = "is_android"];
   */
  isAndroid = false;

  /**
   * @generated from field: string environment = 8;
   */
  environment = "";

  /**
   * @generated from field: google.protobuf.Timestamp create_date = 9 [json_name = "create_date"];
   */
  createDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_date = 10 [json_name = "update_date"];
   */
  updateDate?: Timestamp;

  /**
   * @generated from field: string version = 11;
   */
  version = "";

  constructor(data?: PartialMessage<Maintenance>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "entity.Maintenance";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "maintenance_type", jsonName: "maintenance_type", kind: "enum", T: proto3.getEnumType(MaintenanceType) },
    { no: 3, name: "begin_date", jsonName: "begin_date", kind: "message", T: Timestamp },
    { no: 4, name: "end_date", jsonName: "end_date", kind: "message", T: Timestamp },
    { no: 5, name: "is_enabled", jsonName: "is_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "is_ios", jsonName: "is_ios", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "is_android", jsonName: "is_android", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "environment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "create_date", jsonName: "create_date", kind: "message", T: Timestamp },
    { no: 10, name: "update_date", jsonName: "update_date", kind: "message", T: Timestamp },
    { no: 11, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Maintenance {
    return new Maintenance().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Maintenance {
    return new Maintenance().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Maintenance {
    return new Maintenance().fromJsonString(jsonString, options);
  }

  static equals(a: Maintenance | PlainMessage<Maintenance> | undefined, b: Maintenance | PlainMessage<Maintenance> | undefined): boolean {
    return proto3.util.equals(Maintenance, a, b);
  }
}

